var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useAccountSummaryV2Query } from 'syf-api/accountSummary/accountSummaryV2Query';
import query from 'syf-component-library/const/mediaQueries';
import DrawerHeader from 'syf-component-library/ui/atoms/DrawerHeader';
import Inset from 'syf-component-library/ui/spacing/Inset';
import { assetsURL } from '../../../const/mfe-config';
import { useMainContext } from '../../../context';
import useMediaQuery from '../../../hooks/use-media-query';
import useTranslation from '../../../hooks/use-translation';
var CardHeader = function () {
    var _a;
    var i18n = useTranslation();
    var _b = useMainContext(), accountId = _b.accountId, accountIdType = _b.accountIdType, config = _b.config;
    var accountSummary = useAccountSummaryV2Query({
        config: config,
        keyProps: {
            accountId: accountId,
            accountIdType: accountIdType
        },
        queryOptions: {
            enabled: Boolean(accountId) && Boolean(accountIdType)
        }
    }).data;
    var isMobile = useMediaQuery(query.lessThanSmall);
    var insetPadding = isMobile ? 'medium' : 'large';
    var defaultCardArt = "".concat(assetsURL, "/assets/cardArt/syf_generic_card.svg");
    var drawerHeader = {
        title: accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.product.displayName,
        subtitle: i18n('accountCard.endingInText', {
            accountLast4: accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.accountInfo.accountLast4
        }),
        img: (_a = accountSummary === null || accountSummary === void 0 ? void 0 : accountSummary.card.cardArtURL) !== null && _a !== void 0 ? _a : defaultCardArt,
        fallbackImage: defaultCardArt,
        alt: ''
    };
    return (_jsx(Inset, __assign({ all: insetPadding }, { children: _jsx(DrawerHeader, __assign({}, drawerHeader)) })));
};
export default CardHeader;
//# sourceMappingURL=index.js.map